import {
  RequestAbsenceButtonFragment,
  RequestedAbsenceFragment,
} from '../../__generated__/graphql';
import { AbsenceCategory } from './types';
import { FileInput } from './AbsenceFileField';
import { AbsenceDefaultValues } from '../EditAbsenceSidebar/types';
import { normalizeTimeToHHmm } from '../../../../utils/time';
import { Maybe } from 'graphql/jsutils/Maybe';

export const mapEmployeeAbsenceCategoryToAbsenceCategory = (
  cat: RequestAbsenceButtonFragment,
): AbsenceCategory => ({
  id: cat.Id,
  Name: cat.category.Name,
  order: cat.category.flair__Order__c || 0,
  icon: cat.category.flair__Icon__c,
  color: cat.category.flair__Color__c,
  type: cat.category.flair__Type__c,
  unlimited: cat.flair__Unlimited__c,
  withoutBalance: cat.category.flair__Without_Balance__c,
  availableAmount: cat.allowancesSummary?.availableAmount || 0,
  group: cat.category.group,
  policies: cat.absenceRequestPolicies || [],
});

export const mapContentDocumentLinkToFileInput = (
  contentDocumentLink: any,
): FileInput | null => {
  if (!contentDocumentLink?.ContentDocument) return null;

  return {
    fileName: contentDocumentLink.ContentDocument.Title,
    fileContentBase64: '',
  };
};

export const mapAbsenceToDefaultValues = (
  absence: RequestedAbsenceFragment | null | undefined,
): AbsenceDefaultValues | undefined => {
  if (!absence) return undefined;

  const daysTimes = parseDaysTimes(absence.flair__Days_Times__c);

  return {
    startDate: absence.flair__Start_Date__c,
    endDate: absence.flair__End_Date__c,
    startTime: absence.flair__Start_Time__c || '',
    endTime: absence.flair__End_Time__c || '',
    startDateHalfDay: absence.flair__Start_Date_Half_Day__c || false,
    endDateHalfDay: absence.flair__End_Date_Half_Day__c || false,
    note: absence.flair__Comment__c || '',
    attachedFile: absence.ContentDocumentLinks__r?.[0]
      ? mapContentDocumentLinkToFileInput(absence.ContentDocumentLinks__r[0])
      : null,
    daysTimes,
  };
};

const parseDaysTimes = (
  daysTimes: Maybe<string>,
): AbsenceDefaultValues['daysTimes'] => {
  if (!daysTimes) return undefined;

  try {
    const parsed = JSON.parse(daysTimes);
    if (Array.isArray(parsed)) {
      return parsed.map((d) => ({
        currentDate: d.currentDate,
        startTime: normalizeTimeToHHmm(d.startTime),
        endTime: normalizeTimeToHHmm(d.endTime),
      }));
    }
  } catch (e) {
    throw new Error('Invalid days times', { cause: e });
  }
  return undefined;
};
